import { render, staticRenderFns } from "./AsignaSedePersonal.vue?vue&type=template&id=397d3644&scoped=true"
import script from "./AsignaSedePersonal.vue?vue&type=script&lang=js"
export * from "./AsignaSedePersonal.vue?vue&type=script&lang=js"
import style0 from "./AsignaSedePersonal.vue?vue&type=style&index=0&id=397d3644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d3644",
  null
  
)

export default component.exports